const mapArrayToAssocObject = (items, prop = 'id') => {
  const itemMap = {};
  items.forEach(item => {
    itemMap[item[prop]] = item;
  });
  return itemMap;
};

export default mapArrayToAssocObject;
